import Glide from '@glidejs/glide'
import { throttle } from 'throttle-debounce'

const MOBILE_GLIDE_BREAKPOINT = 768

const BindArrows = function (Glide) {
  // Custom binding as this arrow is outside of the glide element
  return {
    mount() {
      Glide.on(['mount.after', 'run'], () => {
        const arrowRight = document.querySelector(
          `[data-glide-arrow-right-custom="${Glide.selector.id}"]`
        )
        if (arrowRight) {
          arrowRight.addEventListener('click', () => {
            Glide.go('>')
          })
        }

        const arrowLeft = document.querySelector(
          `[data-glide-arrow-left-custom="${Glide.selector.id}"]`
        )
        if (arrowLeft) {
          arrowLeft.addEventListener('click', () => {
            Glide.go('<')
          })
        }
      })
    }
  }
}

const HrefFix = function (Glide) {
  // Fixing a glide JS bug - the href becomes unset.
  return {
    mount() {
      Glide.on(['swipe.end'], () => {
        const faultyHrefs = Glide.selector.querySelectorAll('[data-real-href]')
        if(!faultyHrefs) return
        faultyHrefs.forEach(anchor => {
          anchor.href = anchor.dataset.realHref;
          anchor.dataset.href = anchor.dataset.realHref;
        });
      })
    }
  }
}

/**
 * Standard Glide instantiation
 */
export const glidify = () => {
  const glides = document.querySelectorAll('[data-glide]')
  if (!glides.length) return

  window.blubolt.glideObjects = []

  glides.forEach((glide) => {
    const config = glide.dataset.gliderConfig
      ? JSON.parse(glide.dataset.gliderConfig)
      : {}
    const newGlide = new Glide(glide, config).mount({
      BindArrows,
      HrefFix
    })

    window.blubolt.glideObjects.push(newGlide)
    glide
      .querySelector('[data-hide-initial-load]')
      ?.classList.remove('hide-initial-load')
  })
}

/**
 * Instantiate glides for mobile only
 */
export const glidifyMob = () => {
  const glides = document.querySelectorAll('[data-glide-mob]')
  if (!glides.length) return

  const initGlideOnMobile = () => {
    // TODO: Swap less than
    if (window.blubolt.glides) {
      const keys = Object.keys(window.blubolt.glides)
      keys.forEach((key) => {
        const elem = window.blubolt.glides[key].selector
        const bp = elem.hasAttribute('data-glide-breakpoint') ? parseInt(elem.dataset.glideBreakpoint) : MOBILE_GLIDE_BREAKPOINT
        if (window.innerWidth >= bp) {
          window.blubolt.glides[key].destroy()
          delete window.blubolt.glides[key]
        }
      })
    }
      
    glides.forEach((glide) => {
      const bp = glide.hasAttribute('data-glide-breakpoint') ? parseInt(glide.dataset.glideBreakpoint) : MOBILE_GLIDE_BREAKPOINT
      if(window.innerWidth < bp) {
        const config = glide.dataset.gliderConfig
          ? JSON.parse(glide.dataset.gliderConfig)
          : {}
        const id = glide.dataset.id ? glide.dataset.id : null
  
        if (id) {
          // Only create glide if it hasn't been created yet.
          if (!window.blubolt.glides[id]) {
            const glideInstance = new Glide(glide, config).mount()
            window.blubolt.glides[id] = glideInstance
            glide
              .querySelector('[data-hide-initial-load]')
              ?.classList.remove('hide-initial-load')
          }
        } else {
          console.info('Please add data-id to the slide')
        }
      }
    })
  }

  initGlideOnMobile()
  window.addEventListener(
    'resize',
    throttle(500, false, () => initGlideOnMobile())
  )
}

export default glidify
